module.exports = __webpack_public_path__ + "img/5.3.TP.6316e94a.png";